// Theme: aurora-lux
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'aurora-lux',
  name: 'AURORA LUX',
  tagline: 'AURORA LUX',
  description: 'Aurora boreal em variacao vermelho-rosa sobre ceu frio.',
  category: 'cosmic-scale',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#071225', '#18233D', '#FF6EA8', '#FFEAF4'],
  familyId: 'nord-aurora',
  variantName: 'LUX',
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 30px color-mix(in srgb, var(--primary) 10%, transparent)',
      '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 28%, transparent)'
    },
    shellClasses: 'font-sans theme-aurora-lux'
  },
  colorVars: {
    '--accent': '#FF9CC8',
    '--accent-foreground': '#071225',
    '--background': '#071225',
    '--border': '#4E4A78',
    '--card': '#18233D',
    '--card-border-active': 'rgba(255, 110, 168, 0.42)',
    '--card-completed': '#141E33',
    '--card-foreground': '#FFEAF4',
    '--card-glow': 'rgba(255, 110, 168, 0.10)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#071225',
    '--foreground': '#FFEAF4',
    '--hold-fill': '#FF6EA8',
    '--input': '#4E4A78',
    '--modal-bg': '#071225',
    '--modal-border': '#4E4A78',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px color-mix(in srgb, var(--primary) 10%, transparent)',
    '--muted': '#4E4A78',
    '--muted-foreground': '#FFD2E6',
    '--nav-active': '#FF6EA8',
    '--nav-bg': '#18233D',
    '--popover': '#18233D',
    '--popover-foreground': '#FFEAF4',
    '--primary': '#FF6EA8',
    '--primary-foreground': '#071225',
    '--ring': '#FF6EA8',
    '--secondary': '#4E4A78',
    '--secondary-foreground': '#FFEAF4',
    '--streak': '#FF6EA8',
    '--success': '#22c55e',
    '--success-foreground': '#071225',
    '--xp': '#FF6EA8',
    '--xp-bg': '#18233D'
  },
  resolvedVars: {
    '--accent': '#FF9CC8',
    '--accent-foreground': '#071225',
    '--accent-foreground-hsl': '218 68% 9%',
    '--accent-foreground-oklch': 'from #071225 l c h',
    '--accent-hsl': '333 100% 81%',
    '--accent-oklch': 'from #FF9CC8 l c h',
    '--background': '#071225',
    '--background-hsl': '218 68% 9%',
    '--background-oklch': 'from #071225 l c h',
    '--border': '#4E4A78',
    '--border-hsl': '245 24% 38%',
    '--border-oklch': 'from #4E4A78 l c h',
    '--border-w': '1px',
    '--card': '#18233D',
    '--card-border-active': 'rgba(255, 110, 168, 0.42)',
    '--card-completed': '#141E33',
    '--card-completed-hsl': '221 44% 14%',
    '--card-completed-oklch': 'from #141E33 l c h',
    '--card-foreground': '#FFEAF4',
    '--card-foreground-hsl': '331 100% 96%',
    '--card-foreground-oklch': 'from #FFEAF4 l c h',
    '--card-glow': 'rgba(255, 110, 168, 0.10)',
    '--card-hsl': '222 44% 17%',
    '--card-oklch': 'from #18233D l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#071225',
    '--destructive-foreground-hsl': '218 68% 9%',
    '--destructive-foreground-oklch': 'from #071225 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#FFEAF4',
    '--foreground-hsl': '331 100% 96%',
    '--foreground-oklch': 'from #FFEAF4 l c h',
    '--hold-fill': '#FF6EA8',
    '--hold-fill-hsl': '336 100% 72%',
    '--hold-fill-oklch': 'from #FF6EA8 l c h',
    '--input': '#4E4A78',
    '--input-hsl': '245 24% 38%',
    '--input-oklch': 'from #4E4A78 l c h',
    '--modal-bg': '#071225',
    '--modal-bg-hsl': '218 68% 9%',
    '--modal-bg-oklch': 'from #071225 l c h',
    '--modal-border': '#4E4A78',
    '--modal-border-hsl': '245 24% 38%',
    '--modal-border-oklch': 'from #4E4A78 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px color-mix(in srgb, var(--primary) 10%, transparent)',
    '--muted': '#4E4A78',
    '--muted-foreground': '#FFD2E6',
    '--muted-foreground-hsl': '333 100% 91%',
    '--muted-foreground-oklch': 'from #FFD2E6 l c h',
    '--muted-hsl': '245 24% 38%',
    '--muted-oklch': 'from #4E4A78 l c h',
    '--nav-active': '#FF6EA8',
    '--nav-active-hsl': '336 100% 72%',
    '--nav-active-oklch': 'from #FF6EA8 l c h',
    '--nav-bg': '#18233D',
    '--nav-bg-hsl': '222 44% 17%',
    '--nav-bg-oklch': 'from #18233D l c h',
    '--popover': '#18233D',
    '--popover-foreground': '#FFEAF4',
    '--popover-foreground-hsl': '331 100% 96%',
    '--popover-foreground-oklch': 'from #FFEAF4 l c h',
    '--popover-hsl': '222 44% 17%',
    '--popover-oklch': 'from #18233D l c h',
    '--primary': '#FF6EA8',
    '--primary-foreground': '#071225',
    '--primary-foreground-hsl': '218 68% 9%',
    '--primary-foreground-oklch': 'from #071225 l c h',
    '--primary-hsl': '336 100% 72%',
    '--primary-oklch': 'from #FF6EA8 l c h',
    '--radius': '12px',
    '--ring': '#FF6EA8',
    '--ring-hsl': '336 100% 72%',
    '--ring-oklch': 'from #FF6EA8 l c h',
    '--secondary': '#4E4A78',
    '--secondary-foreground': '#FFEAF4',
    '--secondary-foreground-hsl': '331 100% 96%',
    '--secondary-foreground-oklch': 'from #FFEAF4 l c h',
    '--secondary-hsl': '245 24% 38%',
    '--secondary-oklch': 'from #4E4A78 l c h',
    '--shadow-card': '0 12px 30px color-mix(in srgb, var(--primary) 10%, transparent)',
    '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 28%, transparent)',
    '--streak': '#FF6EA8',
    '--streak-hsl': '336 100% 72%',
    '--streak-oklch': 'from #FF6EA8 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#071225',
    '--success-foreground-hsl': '218 68% 9%',
    '--success-foreground-oklch': 'from #071225 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(336 100% 72% / 0.15)',
    '--xp': '#FF6EA8',
    '--xp-bg': '#18233D',
    '--xp-bg-hsl': '222 44% 17%',
    '--xp-bg-oklch': 'from #18233D l c h',
    '--xp-hsl': '336 100% 72%',
    '--xp-oklch': 'from #FF6EA8 l c h'
  }
}
